import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

/** The page's pathname, without its query: a report's link carries filters, and the page is current whatever they are. */
export const useCurrentPath = () => {
  const page = usePage()

  return computed(() => new URL(page.url, window.location.origin).pathname)
}
